import React from 'react';
import logo from '../assest/DAWACO_White_Icon.png'; 

const Logo = ({w,h}) => {
  return (
    <img src={logo} alt="DAWACO Logo" style={{ width: w, height: h }} />
  );
};

export default Logo;
